import { useState, useEffect } from "react";
import axios from "axios";
import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";
import { useNavigate } from "react-router-dom";

const UpcomingEvents = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [{ errorLogApi, user }] = useAtom(gbState);
  const navigate = useNavigate();

  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/event/upcoming/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          setData(response.data.events);
          setIsLoading(false);
        })
        .catch(function (err) {
          console.log("error api call ", err);
          setIsLoading(false);
        });
    };
    getDataFromServer();
  }, []);

  if (isLoading) {
    return (
      <div className="p-4 bg-white rounded-lg shadow-sm">
        <div className="flex space-x-4 animate-pulse">
          <div className="flex-1 py-1 space-y-3">
            <div className="w-3/4 h-3 bg-gray-200 rounded"></div>
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 rounded"></div>
              <div className="h-3 bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-semibold text-gray-800">Upcoming Events</h2>
        <button
          onClick={() => navigate("/events-calender")}
          className="flex items-center text-sm font-medium text-blue-600 cursor-pointer hover:text-blue-800"
        >
          View Calendar
          <svg
            className="w-3 h-3 ml-1"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>

      <ul className="space-y-2">
        {data.slice(0, 3).map((event, index) => {
          const startDate = new Date(event.event_start_date);

          return (
            <li
              key={index}
              className="flex items-center p-2 space-x-3 transition-colors duration-150 ease-in-out rounded-md hover:bg-gray-50"
            >
              <div className="flex flex-col items-center justify-center flex-shrink-0 w-12 h-12 border border-blue-100 rounded-md bg-blue-50">
                <div className="text-base font-bold text-blue-600">
                  {startDate.getDate()}
                </div>
                <div className="text-xs font-medium text-blue-500">
                  {startDate.toLocaleString("default", { month: "short" })}
                </div>
              </div>
              <div className="flex-grow">
                <div className="text-sm font-medium text-gray-900">
                  {event.title}
                </div>
                <div className="flex items-center text-xs text-gray-500">
                  <svg
                    className="w-3 h-3 mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  {event.event_start_time.substring(0, 5)}
                </div>
              </div>
            </li>
          );
        })}
      </ul>

      {/* {data.length > 3 && (
        <div className="mt-3 text-center">
          <button
            onClick={() => navigate("/events-calender")}
            className="inline-flex items-center px-3 py-1.5 text-xs font-medium text-white transition-colors duration-150 ease-in-out bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            View All Events
            <svg
              className="w-3 h-3 ml-1"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          </button>
        </div>
      )} */}
    </div>
  );
};

export default UpcomingEvents;
